export const MessageContent = {
  CreditCardValidationFailed: {
    title: 'מנוי יקר, נמצאה בעיה באמצעי התשלום שהזנת',
    subTitle: 'נא הזן אמצעי תשלום אחר, או פנה לאיש הקשר',
    icon: require('./icons/error.svg'),
    buttonText: 'סיום',
  },
  PaymentValidationFailed: {
    title: 'מנוי יקר, נמצאה בעיה באמצעי התשלום שהזנת',
    subTitle: 'נא הזן אמצעי תשלום אחר, או פנה לאיש הקשר',
    icon: require('./icons/error.svg'),
    buttonText: 'סיום',
  },
  CreateBanSuccess: {
    title: 'תהליך הרישום הסתיים בהצלחה !',
    subTitle: ' תהנו מהקו החדש שלכם',
    icon: require('./icons/like.svg'),
    buttonText: 'סיום',
    redirectPath: 'selfcareLobby',
  },
  UpdateUserSucceeded: {
    title: 'תהליך העדכון הסתיים בהצלחה !',
    subTitle: ' תהנו מהקו החדש שלכם',
    icon: require('./icons/like.svg'),
    buttonText: 'סיום',
    redirectPath: 'selfcareLobby',
  },
  TempFailure: {
    title: '',
    subTitle: 'לקבלת מידע נוסף והשלמת התהליך ניתן לפנות לאיש הקשר שלך',
    icon: require('./icons/heyIcon.svg'),
    buttonText: 'הבנתי , תודה',
    redirectPath: '',
  },

  GeneralError: {
    title: "מצטערים, כרגע לא ניתן לבצע את הפעולה שביקשת",
    subTitle: 'לקבלת מידע נוסף והשלמת התהליך ניתן לפנות לאיש הקשר שלך',
    icon: require('./icons/error.svg'),
    buttonText: 'סיום',
    redirectPath: '',
  },
  NoPlanDetailsFound: {
    title: "מצטערים, כרגע לא ניתן לבצע את הפעולה שביקשת",
    subTitle: 'לא נמצאו פרטי תוכנית. יש לפנות לאיש קשר בארגון',
    icon: require('./icons/error.svg'),
    buttonText: 'סיום',
    redirectPath: '',
  },
  UpgradeSuccess: {
    title: 'התהליך הסתיים בהצלחה !',
    subTitle: ' תהנו מהמכשיר החדש שלכם',
    icon: require('./icons/like.svg'),
    buttonText: 'סיום',
    redirectPath: 'selfcareLobby',
  }
};

export const NumOfPaymentsArr = [1, 6, 12];
